import { useState, useEffect, useRef } from "react";
import {
  MobileTournamentITMBack,
  MobileTournamentITMHeader,
  MobileTournamentITMItem,
  MobileTournamentITMTable,
  MobileTournamentITMWrapper,
} from "./style";
import { TournamentResponse } from "../../../../../../api/tournament";
import { getTournamentPrizeList } from "../../../../../../api/tournament-prize";
import PopupPagination from "../../../../../../component/Pagination/popupPagination";

interface ItmDto {
  rank: number;
  nickname: string;
  prize: number;
}

const MobileTournamentMoreITM = ({
  tournament,
}: {
  tournament: TournamentResponse | null;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<ItmDto[]>([]);
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const getPrizeList = async () => {
    if (!tournament) return;
    const res = await getTournamentPrizeList(tournament.id);
    const newList: ItmDto[] = res.prizeList.map((t, i) => {
      return {
        rank: i + 1,
        prize: t.seedPrize,
        nickname: t.nickname || "시상대기",
      };
    });
    setList(newList);
  };

  useEffect(() => {
    getPrizeList();
  }, [tournament]);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open ? contentRef.current.scrollHeight + 56 + 20 : 56);
    }
  }, [open]);

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(list.length / 7)));
    setList(list.slice((currentPage - 1) * 7, currentPage * 7));
  }, [list]);

  useEffect(() => {
    setList(list.slice((currentPage - 1) * 7, currentPage * 7));
  }, [currentPage]);

  const handlePrize = (item: ItmDto) => {
    const moneyInChip = tournament?.moneyInChip.find(
      (m) => m.rank === item.rank,
    );

    if (moneyInChip?.isSubPrize) return moneyInChip.subPrize;

    return item.prize.toLocaleString();
  };

  return (
    <MobileTournamentITMWrapper contentHeight={contentHeight}>
      <MobileTournamentITMHeader onClick={() => setOpen(!open)} open={open}>
        <div className="title">ITM 순위</div>
        <img src="image-web/icon/down_arrow.svg" alt="more" />
      </MobileTournamentITMHeader>
      <MobileTournamentITMBack ref={contentRef} open={open}>
        <MobileTournamentITMTable isHeight={totalPages > 1}>
          {list.map((item, index) => (
            <MobileTournamentITMItem key={index}>
              <div className="user">
                <div className="rank">{item.rank}위</div>
                <div className="nickname">{item.nickname}</div>
              </div>
              <div className="point">{handlePrize(item)}</div>
            </MobileTournamentITMItem>
          ))}
        </MobileTournamentITMTable>
        {totalPages > 1 && (
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </MobileTournamentITMBack>
    </MobileTournamentITMWrapper>
  );
};

export default MobileTournamentMoreITM;
